<template>
  <div class="intelligent-security">
    <div id="popular">
      <div class="none">
        <div class="a" onclick="toggle()"></div>
        <h1>资料下载</h1>
        <table>
          <tr>
            <th>文件名称</th>
            <th>文件格式</th>
            <th>文件大小</th>
            <th>操作</th>
          </tr>
          <tr v-for="(person, index) in arr" :key="index">
            <td>
              <div>{{ person.fileName }}</div>
            </td>
            <td>
              <div>{{ person.fileFormat }}</div>
            </td>
            <td>
              <div>{{ person.fileSize }}</div>
            </td>
            <!-- <td><img @click='download(person.url,person.fileName)' src="../assets/img/buliding/icon_download.png" alt=""></td> -->
            <!-- <td><img @click="downLoadAjaxEvt('get',person.url)" src="../assets/img/buliding/icon_download.png" alt=""></td> -->
            <td>
              <img
                @click="download(person.url, person.fileName)"
                src="../assets/img/buliding/icon_download.png"
                alt=""
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div id="acc"></div>

    <div id="blur">
      <header>
        <div class="main">
          <!-- <img
            src="../assets/img/download2/智能安防_下载资源_banner@2x.png"
            class="banner"
          /> -->
          <div class="banner"></div>

          <div class="left"></div>

          <div class="right"></div>
        </div>
      </header>

      <main>
        <div class="main">
          <div class="main-background1"></div>
          <div class="main-background2"></div>
          <div class="main-background3"></div>
          <div class="left"></div>
          <div class="center">
            <div class="main1">
              <div class="main1-background">SMART</div>
              <!-- <h1>智能安防</h1> -->
              <h1>城市智能化</h1>
              <p>
                涵盖了所有以行政区域（省/市/县/区等）为层级的智能化建设/改造业务，包括但不限于地铁站，道路监测，公共停车场，水利，林业，农业等；在此业务线中，昌恩较有代表性的案例有…….（填写道路监控案例，其他相关案例的名称）等
              </p>
            </div>

            <div class="main2">
              <div class="main2Center">
                <div class="dimg1">
                  <img
                    src="../assets/img/download2/智能安防_下载资源1@2x.png"
                    alt=""
                  />
                </div>

                <div class="main-text">
                  <h1>智能安防</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
              </div>
            </div>

            <div class="main3">
              <div class="dimg2">
                <img
                  src="../assets/img/download2/智能安防_下载资源2@2x.png"
                  alt=""
                />
              </div>

              <div class="main-text">
                <h1>智能安防</h1>
                <p>
                  智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                </p>
              </div>
            </div>

            <div class="main4">
              <div class="main4-left">
                <div class="main-text">
                  <h1>智能安防</h1>
                  <p>
                    智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。
                  </p>
                </div>
                <p class="p">
                  联系电话：0755-83932176<i
                    >地址：深圳市盐田区沙头角深盐路保发大厦5楼整层</i
                  >
                </p>

                <button onclick="toggle()">
                  下载资料<img
                    src="../assets/img/download2/icon_more@2x.png"
                    alt=""
                  />
                </button>
              </div>
              <div class="dimg3">
                <img
                  src="../assets/img/download2/智能安防_下载资源3@2x.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="right"></div>
        </div>
      </main>
    </div>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from "../components/footer.vue";

export default {
  components: { Footer },
  name: "security",
  data() {
    return {
      arr: [],
    };
  },
  //防止 div中的onclick 找不到
  created() {
    window.toggle = this.toggle;
    window.download = this.download;
  },
  mounted() {
    this.toggle2();
  },
  methods: {
    downloadEvt(url, fileName = "未知文件") {
      const el = document.createElement("a");
      el.style.display = "none";
      el.setAttribute("target", "_blank");
      /**
       * download的属性是HTML5新增的属性
       * href属性的地址必须是非跨域的地址，如果引用的是第三方的网站或者说是前后端分离的项目(调用后台的接口)，这时download就会不起作用。
       * 此时，如果是下载浏览器无法解析的文件，例如.exe,.xlsx..那么浏览器会自动下载，但是如果使用浏览器可以解析的文件，比如.txt,.png,.pdf....浏览器就会采取预览模式
       * 所以，对于.txt,.png,.pdf等的预览功能我们就可以直接不设置download属性(前提是后端响应头的Content-Type: application/octet-stream，如果为application/pdf浏览器则会判断文件为 pdf ，自动执行预览的策略)
       */
      fileName && el.setAttribute("download", fileName);
      el.href = url;
      console.log(el);
      document.body.appendChild(el);
      el.click();
      document.body.removeChild(el);
    },

    // 根据header里的contenteType转换请求参数
    transformRequestData(contentType, requestData) {
      requestData = requestData || {};
      if (contentType.includes("application/x-www-form-urlencoded")) {
        // formData格式：key1=value1&key2=value2，方式二：qs.stringify(requestData, {arrayFormat: 'brackets'}) -- {arrayFormat: 'brackets'}是对于数组参数的处理
        let str = "";
        for (const key in requestData) {
          if (Object.prototype.hasOwnProperty.call(requestData, key)) {
            str += `${key}=${requestData[key]}&`;
          }
        }
        return encodeURI(str.slice(0, str.length - 1));
      } else if (contentType.includes("multipart/form-data")) {
        const formData = new FormData();
        for (const key in requestData) {
          const files = requestData[key];
          // 判断是否是文件流
          const isFile = files
            ? files.constructor === FileList ||
              (files.constructor === Array && files[0].constructor === File)
            : false;
          if (isFile) {
            for (let i = 0; i < files.length; i++) {
              formData.append(key, files[i]);
            }
          } else {
            formData.append(key, files);
          }
        }
        return formData;
      }
      // json字符串{key: value}
      return Object.keys(requestData).length ? JSON.stringify(requestData) : "";
    },
    /**
     * ajax实现文件下载、获取文件下载进度
     * @param {String} method - 请求方法get/post
     * @param {String} url
     * @param {Object} [params] - 请求参数，{name: '文件下载'}
     * @param {Object} [config] - 方法配置
     */
    downLoadAjaxEvt(method = "get", url, params, config) {
      const _method = method.toUpperCase();
      const _config = Object.assign(
        {
          contentType:
            _method === "GET"
              ? "application/x-www-form-urlencoded"
              : "application/json", // 请求头类型
          fileName: "未知文件", // 下载文件名(必填，若为空，下载下来都是txt格式)
          async: true, // 请求是否异步-true异步、false同步
          token: "token", // 用户token
        },
        config
      );

      const queryParams = this.transformRequestData(
        _config.contentType,
        params
      );
      const _url = `${url}${
        _method === "GET" && queryParams ? "?" + queryParams : ""
      }`;

      const ajax = new XMLHttpRequest();
      ajax.open(_method, _url, _config.async);
      ajax.setRequestHeader("Authorization", _config.token);
      ajax.setRequestHeader("Content-Type", _config.contentType);
      // responseType若不设置，会导致下载的文件可能打不开
      ajax.responseType = "blob";
      // 获取文件下载进度
      ajax.addEventListener("progress", (progress) => {
        const percentage = ((progress.loaded / progress.total) * 100).toFixed(
          2
        );
        const msg = `下载进度 ${percentage}%...`;
        console.log(msg);
      });
      ajax.onload = function () {
        if (this.status === 200 || this.status === 304) {
          // 通过FileReader去判断接口返回是json还是文件流
          const fileReader = new FileReader();
          fileReader.onloadend = (e) => {
            if (
              this.getResponseHeader("content-type").includes(
                "application/json"
              )
            ) {
              const result = JSON.parse(
                fileReader.result || "{message: 服务器出现问题，请联系管理员}"
              );
              alert(result.message);
            } else {
              // 两种解码方式，区别自行百度: decodeURIComponent/decodeURI（主要获取后缀名，否则低版本浏览器会一律识别为txt，导致下载下来的都是txt）
              const _fileName = decodeURIComponent(
                (
                  this.getResponseHeader("content-disposition") ||
                  '; filename="未知文件"'
                )
                  .split(";")[1]
                  .trim()
                  .slice(9)
              );
              /**
               * Blob.type一个字符串，表明该 Blob 对象所包含数据的 MIME 类型。如果类型未知，则该值为空字符串。
               * 对于pdf：type为application/pdf  同时 a标签 不设置download属性, 可以直接预览
               */
              const blob = new Blob([this.response]);
              const href = URL.createObjectURL(blob);
              downloadEvt(href, _fileName);
              // 释放一个之前已经存在的、通过调用 URL.createObjectURL() 创建的 URL 对象
              URL.revokeObjectURL(href);
            }
          };
          // 调用readAsText读取文件，少了readAsText将不会触发onloadend事件
          fileReader.readAsText(this.response);
        } else {
          alert("服务器出现问题，请联系管理员");
        }
      };
      // send(string): string：仅用于 POST 请求
      ajax.send(queryParams);
    },

    toggle() {
      var blur = document.getElementById("blur");
      blur.classList.toggle("active");
      var acc = document.getElementById("acc");
      acc.classList.toggle("active");
      var popular = document.getElementById("popular");
      popular.classList.toggle("active");
    },
    toggle2() {
      this.request.get("/information/1", {}).then((res) => {
        console.log(res.data.data);
        this.arr = res.data.data;
      });
    },

    download2(url, name) {
      var xhr = new XMLHttpRequest();
      xhr.open("get", url);
      xhr.responseType = "blob";
      xhr.send();
      xhr.onload = function () {
        var fileBlob = xhr.response;
        console.log(fileBlob);
        var fileUrl = URL.createObjectURL(fileBlob);
        //document.querySelector("img").setAttribute('src',fileUrl)
        var addElement = document.createElement("a");
        addElement.innerHTML = "点击";
        addElement.href = fileUrl;
        addElement.download = "a.png";
        document.body.appendChild(addElement);
      };
    },
    download(url, fileName) {
      window.open("https://www.szce.com/api/common/download/" + fileName);
      // console.log(fileName+"@@@@@@@")
      // const element = document.createElement('a');
      // element.setAttribute('download', fileName);
      // let binaryData = [];
      // binaryData.push(url);
      // element.setAttribute('href', window.URL.createObjectURL(new Blob(binaryData)));
      // document.body.appendChild(element);
      // element.click();
      // document.body.removeChild(element);

      // 图片直接预览
      //  window.open("http://119.23.229.41:12000/files/2022/10/27/16668711965150a656000ce36c5b5ca73f7a33753d2f.png",'_self');

      //加载自第三方上下文，并已开启动态状态分区功能，已授权该网站访问分区的 Cookie 或存储空间。
      //    var urll = "http://119.23.229.41:12000/files/2022/10/27/16668711965150a656000ce36c5b5ca73f7a33753d2f.png";
      // const iframe = document.createElement('iframe');
      // iframe.style.display = 'none';
      // iframe.src = urll;
      // document.body.appendChild(iframe);
      // setTimeout(() => {
      //   document.body.removeChild(iframe);
      //   }, 200);
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 1060px) {
  #popular .none {
    transform: scale(0.6);
  }
}
@media screen and (max-width: 1260px) and (min-width: 1060px) {
  #popular .none {
    transform: scale(0.7);
  }
}
@media screen and (max-width: 1360px) and (min-width: 1260px) {
  #popular .none {
    transform: scale(0.8);
  }
}

@media screen and (max-width: 1260px) {
  body .main2 .main-text {
    margin-left: -150px;
  }
  body .main2 .dimg1 {
    width: 100%;
  }
}
.main2Center {
  width: 1260px;
  margin: 0 auto;
}

header {
  /* height: 187px; */
  height: 230px;
}

#blur.active {
  pointer-events: none;
  user-select: none;
}
#acc.active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.77);
  z-index: 998;
}
#popular {
  position: fixed;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 1200px;
  height: 600px;
  z-index: 999;
  visibility: hidden;
  opacity: 0;
  transition: 0.5s;
}
#popular .none {
  position: relative;
  width: 1200px;
  height: 100%;
  background-color: white;
  padding: 20.0064px 39.9936px 0 20.0064px;
}
.none .a {
  position: absolute;
  right: -56px;
  top: -16px;
  display: block;
  width: 32px;
  height: 32px;
  cursor: pointer;
  background: url(../assets//img/case/icon_close@2x.png) no-repeat;
  background-size: 100% 100%;
}
.none h1 {
  margin-bottom: 20.0064px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.58);
  line-height: 24px;
}
.none table {
  border-collapse: collapse;
  width: 100%;
}
td,
th {
  border-bottom: 0.9984px solid #000000;
  text-align: left;
  padding: 16px 83px;
  white-space: nowrap;
}
th {
  color: rgba(0, 0, 0, 0.58);
  font-size: 14px;
  font-weight: 500;
  line-height: 22px;
}
td {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  line-height: 22px;
}
#popular.active {
  top: 45%;
  visibility: visible;
  opacity: 1;
  transition: 0.5s;
}
main {
  position: relative;
}
/* header {
  height: 230px;
} */
.banner {
  background: url(../assets/img/download2/智能安防_下载资源_banner@2x.png)
    no-repeat;
  background-position: 100%;
  background-size: cover;
}
.main-background1 {
  position: absolute;
  top: 667px;
  width: 100%;
  /* left:50%;
  margin-left:-780px; */
  height: 326px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background2 {
  position: absolute;
  top: 1133px;
  left: 50%;
  transform: translate(-50%, 0);
  width: 707px;
  height: 536px;
  background: #f5f6fb;
  z-index: -1;
}
.main-background3 {
  position: absolute;
  top: 1806px;
  width: 100%;
  /* left:50%;
  margin-left:-780px; */
  height: 520px;
  background: #f5f6fb;
  z-index: -1;
}
.main1 {
  width: 1260px;
  left: 50%;
  position: relative;
  margin-left: -630px;
  height: 434px;
}
.main1-background {
  position: absolute;
  top: 144px;
  left: 50%;
  transform: translate(-50%, 0);
  font-size: 163px;
  font-weight: normal;
  color: #fafafa;
  line-height: 187px;
  letter-spacing: 6px;
  z-index: -1;
}
.main1 h1 {
  position: absolute;
  top: 206px;
  left: 50%;
  transform: translate(-50%, 10px);
  font-size: 31px;
  color: #140047;
  line-height: 33px;
  letter-spacing: 1.92px;
  text-align: center;
}
.main1 p {
  position: absolute;
  display: block;
  width: 1024px;
  left: 50%;
  margin-left: -517px;
  top: 275px;
  height: 77px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #01021b;
  line-height: 33px;
  letter-spacing: 0.96px;
}
.main2 {
  position: relative;
  display: flex;
  justify-content: flex-end;
  margin-top: 161px;
  height: 578px;
}
.main2 .main-text {
  position: absolute;
  padding: 44px;
  width: 634px;
  height: 259px;
  top: -75px;
  left: 50%;
  margin-left: 100px;
}
.main2 .main-text h1 {
  font-size: 31px;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
  line-height: 42px;
  letter-spacing: 2px;
}
.main-text {
  padding: 40px;
  /* height: 319px; */
  background: #ffffff;
  box-shadow: 0rem 0.9984px 10px 0rem rgba(176, 183, 213, 0.2);
}
.main-text h1 {
  margin-bottom: 27px;
  font-size: 38px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.main-text p {
  font-size: 16px;
  font-weight: 400;
  color: #01021b;
  line-height: 40px;
  letter-spacing: 0.96px;
}
.main3 {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-top: 70px;
}
.main3 img {
  margin-right: 44px;
  width: 720px;
  height: 566px;
}
.main4 {
  margin-top: 112px;
  display: flex;
  width: 100%;
  justify-content: center;
}
.main4 img {
  margin-left: 44px;
  width: 720px;
  height: 566px;
}
.main4-left .p {
  margin: 32px 0;
  font-size: 16px;
  font-weight: 500;
  color: #140047;
  line-height: 28px;
  letter-spacing: 0.96px;
  opacity: 1;
}
.main4-left .p i {
  margin-left: 26px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #140047;
  line-height: 23px;
  letter-spacing: 1px;
}
.main4-left button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px;
  height: 52px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  border: 0.96px solid #140047;
  font-size: 18px;
  font-weight: 600;
  color: #140047;
  line-height: 24px;
  cursor: pointer;
  transition: all 0.3s;
}
.main4-left button img {
  width: 18px;
  height: 10px;
  margin-left: 40px;
}
button:hover {
  margin-left: 30.0096px;
}
.dimg1 {
  width: 1196px;
  height: 470px;
}
.dimg1 img {
  width: 100%;
  height: 100%;
}
.dimg2 {
  width: 611px;
  height: 486px;
  margin-right: 36px;
}
.dimg2 img {
  width: 100%;
  height: 100%;
}

.main3 .main-text {
  width: 634px;
  /* height:259px; */
}
.main4 .main-text {
  width: 634px;
  height: 259px;
}
.dimg3 {
  width: 611px;
  height: 475px;
  /* margin-top: 12px; */
  margin-top: -12px;
  padding-bottom: 30px;
}
.dimg3 img {
  width: 100%;
  height: 100%;
}
img {
  border: 1px dashed #808080;
}
p {
  opacity: 0.72;
}
</style>



// WEBPACK FOOTER //
// src/components/security.vue